<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="893px">
    <v-card>
      <v-card-title>
        <h2 v-if="messageTitle" class="md-title">
          {{ messageTitle | translate }}
        </h2>
      </v-card-title>
      <v-card-text class="px-4 pt-0">
        <div v-if="htmlContent" v-html="messageText" class="my-3"></div>
        <p v-else-if="translate" class="my-3">{{ messageText | translate }}</p>
        <p v-else class="my-3">{{ messageText }}</p>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex xs12 text-xs-right class="pr-2">
            <v-btn flat @click="closeDialog" class="def-btn">{{
              "lng_close" | translate
            }}</v-btn>
            <v-btn flat @click="giveAccess" class="def-btn">{{
              OkButtonText | translate
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TechAccessDialog",
  data() {
    return {
      dialog: false
    };
  },
  props: {
    messageText: {
      type: String,
      default: "lng_smith_warning"
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    giveAccess: {
      type: Function,
      default: undefined
    },
    translate: {
      type: Boolean,
      default: true
    },
    messageTitle: {
      type: String,
      default: ""
    },
    OkButtonText: {
      type: String,
      default: "lng_ok"
    },
    htmlContent:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  }
};
</script>
<style scoped>
.def-btn {
  color: rgb(84, 110, 122);
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
}
</style>
